import React, { useState } from "react";

/* Shared Imports */
import ClaimReportGlasses from "./ClaimReportGlasses";
import ClaimReportBuilding from "./ClaimReportBuilding";
import ClaimReportEnterprise from "./ClaimReportEnterprise";
import ClaimReportMachine from "./ClaimReportMachine";
import ClaimReportMotorVehicle from "./ClaimReportMotorVehicle";
import ClaimReportTheft from "./ClaimReportTheft";
import ClaimReportLiabilityDamage from "./ClaimReportLiabilityDamage";
import { Flex, Title } from "@gjensidige/builders-components";
import FormDropdown from "./components/FormDropdown";

const SkadeDIByggeri = () => {
  const [claimType, setClaimType] = useState("");

  const onDropdownChange = (value: string) => {
    setClaimType(value);
  };

  const dropDownOptions = [
    "Ansvarsskade",
    "Brilleskade",
    "Bygningsskade",
    "Entrepriseskade",
    "Maskinskade",
    "Motorkøretøj",
    "Tyveri",
  ];

  const renderReport = () => {
    switch (claimType) {
      case "Ansvarsskade":
        return <ClaimReportLiabilityDamage claimType={claimType} />;
      case "Brilleskade":
        return <ClaimReportGlasses claimType={claimType} />;
      case "Bygningsskade":
        return <ClaimReportBuilding claimType={claimType} />;
      case "Entrepriseskade":
        return <ClaimReportEnterprise claimType={claimType} />;
      case "Maskinskade":
        return <ClaimReportMachine claimType={claimType} />;
      case "Motorkøretøj":
        return <ClaimReportMotorVehicle claimType={claimType} />;
      case "Tyveri":
        return <ClaimReportTheft claimType={claimType} />;
      default:
        return null;
    }
  };

  return (
    <Flex center={"md"} fill layout={1}>
      <Title size={4}>Anmeld skade</Title>
      <FormDropdown
        id="claimType"
        labelText="Hvilken skade vil du anmelde?"
        options={dropDownOptions}
        value={claimType}
        onChange={(values, value) => onDropdownChange(value)}
      />
      {renderReport()}
    </Flex>
  );
};

export default SkadeDIByggeri;
